import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Center from "../common/components/Center";
import VerticalCenter from "../common/components/VerticalCenter";
import Stack from "../common/components/Stack";
import Padding from "../common/components/Padding";
import { selectPathType } from "../features/journey/select";
import OffRamp from "./OffRamp";

const Question3Intro = () => {
  const { t } = useTranslation();
  const pathType = useSelector(selectPathType);
  const heading = (
    <>
      <h2>
        {t(
          "It’s time for our final questions. We’re moving beyond the algorithm now – these ones are just for you."
        )}
      </h2>
      <h2>{t("We invite you to consider: what comes next?")}</h2>
    </>
  );

  if (pathType === "GALLERY") return <OffRamp>{heading}</OffRamp>;

  return (
    <VerticalCenter>
      <Padding>
        <Center>
          <Stack>{heading}</Stack>
        </Center>
      </Padding>
    </VerticalCenter>
  );
};

export default Question3Intro;
